'use client';
import { NEUTRAL_WHITE, SPACING_3 } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';

export const Section = styled.section<{ $bgColor?: string; $imgUrl?: string }>`
  position: relative;
  overflow: hidden;
  border-radius: 1rem;
  border: 0;
  background: ${NEUTRAL_WHITE};
  padding: ${SPACING_3};
  display: flex;
  gap: 1.5rem;
  flex-direction: column;
  ${({ $bgColor }) => $bgColor && `background: ${$bgColor};`}
  ${({ $imgUrl }) =>
    $imgUrl &&
    `
    background: linear-gradient(238deg, rgba(0, 0, 0, 0) 46.74%, #000 97.05%), url('${$imgUrl}') no-repeat center / cover;
    `}
`;
